/**
 * Goal FAB — Floating Action Button for creating new goals.
 */

import React from 'react'
import { Plus } from 'lucide-react'
import { useGoalsStore } from '@turnifly/shared/stores'

export const GoalFab: React.FC = () => {
  const openCreate = useGoalsStore((s) => s.openCreate)

  return (
    <div className="fixed bottom-[calc(var(--tg-safe-area-inset-bottom)+80px)] right-4 z-40">
      <button
        onClick={openCreate}
        className="w-14 h-14 bg-primary text-white rounded-full flex items-center justify-center shadow-lg shadow-primary/30 hover:scale-105 transition-transform active:scale-95 tap-highlight-transparent"
        aria-label="New goal"
      >
        <Plus size={24} strokeWidth={2.5} />
      </button>
    </div>
  )
}
